import React, { useState, useEffect, useContext} from "react";
import { Helmet } from 'react-helmet';
import HeaderWave from '../../layout/HeaderWave';
import HeaderGradient from '../../layout/HeaderGradient';
import UplyftPhoneAppInfo from './UplyftPhoneAppInfo';
import UplyftInfoLanding from "./UplyftInfoLanding";
import LandingPageSectionA from "./LandingPageSectionA"
import LandingPageSectionA_esp from "./LandingPageSectionA_esp"

import UplyftPhoneAppInfo_esp from './UplyftPhoneAppInfo_esp';
import UplyftInfoLanding_esp from "./UplyftInfoLanding_esp";

import './Landing.css';
import { MerchantStateContext } from '../application/context/MerchantStateContext';
import ServerError from "../application/components/ServerError";

export default function Layout({
    title = "Title",
    htmlTitle,
    className,
    children,
    invokeFunction,
    props
}) {
    const { setMainState, mainState, handleChange, lang } = useContext(MerchantStateContext);
    const { is_spanish } = lang ;
    const [serverError, setServerError] = useState(false);

	useEffect(() => {
		let sessionData = sessionStorage['data']? JSON.parse(sessionStorage.getItem("data")):'';
		if (sessionData.app){
			setServerError({message:<> Your signed application has already been submitted. <br/>If you need to make changes or have received this message in error, please contact one of our funding advisors at the email below.<br/><br/><a href="mailto:sales@uplyftcapital.com"><p style={{color:"#6b1cf5"}}>Click here to email us: sales@uplyftcapital.com</p></a></> })
		};
    }, []);

    const clickSubmit = e => { invokeFunction(e); };

    const testimonials = [
      {
        avatar: 'https://cdn.prod.website-files.com/67d8f70e970d3c34ab1e9003/67da5b53089c1860cbbd026e_400.jpeg',
        name: 'Michael Torres',
        title: 'CEO, Metro Electronics',
        testimonial: 'The application process was incredibly smooth. We were approved within 48 hours.',
        backgroundColor: '#ffffff', // white
      },
      {
        // avatar: 'https://cdn.prod.website-files.com/67d8f70e970d3c34ab1e9003/67da5f835862a2ff9721c651_photo-1581091226825-a6a2a5aee158.avif',
        avatar: 'https://cdn.prod.website-files.com/605370362d0fed03fbf3c189/67ece13d1ebc5a06f8a3a033_400%20(1).jpeg',
        name: 'David Chen',
        title: 'Founder, Alpine Outfitters',
        testimonial: 'As a seasonal business, we needed funding that understood our revenue fluctuations.',
        backgroundColor: '#FEFCEA', // floral white
      },
      {
        avatar: 'https://cdn.prod.website-files.com/67d8f70e970d3c34ab1e9003/67da5f835862a2ff9721c651_photo-1581091226825-a6a2a5aee158.avif',
        // avatar: 'https://cdn.prod.website-files.com/605370362d0fed03fbf3c189/67ece13d1ebc5a06f8a3a033_400%20(1).jpeg',
        name: 'Sarah Johnson',
        title: 'Owner, Coastal Kitchen',
        testimonial:
          'Uplyft Capital provided the funding we needed to expand our restaurant when traditional banks said no. The process was fast and the terms were fair.',
          backgroundColor: '#F1E8FD', // light purple
      },
      {
        avatar: 'https://cdn.prod.website-files.com/67d8f70e970d3c34ab1e9003/67da5f94fd2d6a94c4068d81_photo-1649972904349-6e44c42644a7.avif',
        name: 'Jessica Williams',
        title: 'Director, Bloom Boutique',
        testimonial: 'What impressed me most was the transparency. No hidden fees, clear terms.',
      
        backgroundColor: '#f0f8ff', // light blue
      },
      {
        // avatar: 'https://cdn.prod.website-files.com/67d8f70e970d3c34ab1e9003/67da5b53089c1860cbbd026e_400.jpeg',
        avatar: 'https://cdn.prod.website-files.com/67d8f70e970d3c34ab1e9003/67da27d37bc6138008562eaf_100%20(1).jpeg',
        name: 'Robert Miller',
        title: 'Operations, Precision Manufacturing',
        testimonial: 'When our equipment suddenly failed, we needed capital fast. Uplyft delivered.',
        backgroundColor: '#effdf4'
      }
    ];

    const AvatarStarsSection = () => {
      return (
        <div className="d-flex align-items-center">
          {/* Avatar pictures - Overlapping using flexbox */}
          <div className="d-flex">
            {[...Array(5)].map((_, index) => (
              <img
                key={index}
                src={`https://randomuser.me/api/portraits/men/${index + 1}.jpg`} // Replace with actual avatar URLs
                alt={`avatar-${index}`}
                className="rounded-circle"
                style={{
                  width: '20px',
                  height: '20px',
                  border: '1px solid white', // White stroke effect
                  marginLeft: index === 0 ? 0 : '-10px', // Slight negative margin to overlap
                }}
              />
            ))}
          </div>
    
          {/* Spacer between Avatars and Stars */}
          <div className="ml-2 d-flex align-items-center">
            {/* Stars */}
            {[...Array(5)].map((_, index) => (
              <svg
                key={index}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="gold"
                className="mr-0"
              >
                <path d="M12 17l-6.12 3.59 1.6-7.7-5.23-4.6 6.87-.5L12 2l2.88 6.89 6.88.5-5.24 4.6 1.6 7.7L12 17z" />
              </svg>
            ))}
          </div>
    
          {/* Text */}
          <div className="ml-2">
            <p className="m-0" style={{ fontSize: '11px' }}>
              Loved by 20K+ customers
            </p>
          </div>
        </div>
      );
    };
    

    const AvatarStarsSectionWhite = () => {
      return (
        <div className="d-flex align-items-center">
          {/* Avatar pictures - Overlapping using flexbox */}
          <div className="d-flex">
            {[...Array(5)].map((_, index) => (
              <img
                key={index}
                src={`https://randomuser.me/api/portraits/men/${index + 1}.jpg`} // Replace with actual avatar URLs
                alt={`avatar-${index}`}
                className="rounded-circle"
                style={{
                  width: '20px',
                  height: '20px',
                  border: '1px solid white', // White stroke effect
                  marginLeft: index === 0 ? 0 : '-10px', // Slight negative margin to overlap
                }}
              />
            ))}
          </div>
    
          {/* Spacer between Avatars and Stars */}
          <div className="ml-2 d-flex align-items-center">
            {/* Stars */}
            {[...Array(5)].map((_, index) => (
              <svg
                key={index}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="gold"
                className="mr-0"
              >
                <path d="M12 17l-6.12 3.59 1.6-7.7-5.23-4.6 6.87-.5L12 2l2.88 6.89 6.88.5-5.24 4.6 1.6 7.7L12 17z" />
              </svg>
            ))}
          </div>
    
          {/* Text */}
          <div className="ml-2">
            <p className="m-0 text-white" style={{ fontSize: '11px' }}>
              Loved by 20K+ customers
            </p>
          </div>
        </div>
      );
    };
    
      const TestimonialBox = ({ avatar, name, title, testimonial, backgroundColor }) => {
        return (
          <div
            className="box mb-4"
            style={{
              backgroundColor: backgroundColor || '#f9f9f9',
              padding: '20px',
              borderRadius: '14px',
              height: '100%'
            }}
          >
            <div className="d-flex align-items-center mb-3">
              <img
                src={avatar}
                alt={name}
                className="rounded-circle"
                style={{ width: '50px', height: '50px', marginRight: '15px' }}
              />
              <div>
                <div className="font-weight-bold" style={{ fontSize: '12px' }}>
                  {name}
                </div>
                <div className="item-text">{title}</div>
              </div>
            </div>
            <div className="mb-3">
              {[...Array(5)].map((_, index) => (
                <svg
                  key={index}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="gold"
                  className="mr-1"
                >
                  <path d="M12 17l-6.12 3.59 1.6-7.7-5.23-4.6 6.87-.5L12 2l2.88 6.89 6.88.5-5.24 4.6 1.6 7.7L12 17z" />
                </svg>
              ))}
            </div>
            <p className="item-text">{testimonial}</p>
          </div>
        );
      };
      

    return (
        serverError ? <ServerError error={serverError} /> :
        <>
            <HeaderWave />
            <HeaderGradient />
            <Helmet>
                <title>{`Uplyft Capital Onboarding Merchant | ${htmlTitle}`}</title>
           
            </Helmet>
            <main id='merchant_LandingPage' style={{
            // background: 'radial-gradient(circle, rgba(126, 34, 206, 0.4) 0%, rgba(79, 70, 229, 0.3) 70%)',
            // background: linear-gradient(to right, rgba(126, 34, 206, 0.4) 0%, rgba(79, 70, 229, 0.3) 70%),
     
              // background: 'linear-gradient(90deg, rgba(126, 34, 206, 0.4) 0%, rgba(79, 70, 229, 0.3) 70%)',
            
            


            
          }}>
                <section className='container content layoutFading py-4'>
                    <div className={className}>
                        <div className="row">
                            <div className="col-12 col-lg-5">
                                {is_spanish ?
                                    <div className='container display'>
                                        <div className="row">
                                          <div className="col-12 col-lg-12 text-center text-lg-left">
                                            <h1 className="h1-title mt-3">Préstamos de negocios es lo que hacemos!</h1>
                                            <p className="text-white subheader" style={{fontWeight: 400}}>
                                              Aprobado y financiado el mismo día.
                                            </p>
                                            <div className="row mb-4 d-flex justify-content-center justify-content-lg-start">
                                              <div className="col-auto col-lg-12 text-center text-lg-left">
                                              <AvatarStarsSectionWhite/>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                    :
                     
                                      <div className='container display'>
                                        <div className="row">
                                          <div className="col-12 col-lg-12 text-center text-lg-left">
                                            <h1 className="h1-title mt-3">Business Funding is what we do!</h1>
                                            <p className="text-white subheader" style={{fontWeight: 400}}>
                                                Approved and funded the same day.
                                            </p>
                                          </div>
                                        </div>
                                        <div className="row mb-4 d-flex justify-content-center justify-content-lg-start">
                                          <div className="col-auto col-lg-12 text-center text-lg-left">
                                          <AvatarStarsSectionWhite/>
                                          </div>
                                        </div>
                                      </div>
                                      
                                    
                                }
                            </div>
                            <div className="col-12 col-lg-7 ">
                                <form noValidate onSubmit={(e) => clickSubmit(e)} className='pt-5-lg'>
                                    {/* <div>
                                        <h2 className='pb-3'> {title} </h2>
                                    </div> */}
                                    {/* <div id="shadowBox" className="shadow shadowMobile px-4 py-4 mb-2 xs-mx-1 bg-white roundCorners"> */}
                                    <div id="shadowBox" className="shadow shadowMobile px-4 py-4 mb-2 bg-white roundCorners">
                                        {children}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <div id='funding-solutions' style={{background: 'white'}}>
              <div className="container">
                <div className="row">
                <div className='mt-4 mt-lg-8 mb-4 mb-lg-8'>
                {is_spanish ?
                  <LandingPageSectionA_esp />
                  :
                  <LandingPageSectionA />
                  }
                  </div>
               
                </div>
                </div>
              
            </div>
            <div id='testimonials' style={{background: 'white'}} className="mt-4rem">
              <div className="container py-4">
                <div className="row">
                  <div className="col-12 col-lg-4 text-center text-lg-left">
                    <AvatarStarsSection/>
                    {is_spanish ?

                      <>
                        <h1 className="h1-title-dark mt-3">Lo que dicen nuestros clientes</h1>
                        <p className="subheader-dark mt-4">
                          No te fíes solo de nuestra palabra. Conoce a empresas que han crecido exitosamente con nuestras soluciones de financiamiento.
                        </p>
                        <button type="submit" className="btn btn-primary d-flex justify-content-center w-100 mt-4 mb-4">
                          Ver nuestras reseñas
                        </button>
                      </>
                  
                        :

                      <>
                        <h1 className="h1-title-dark mt-3">What our Clients say</h1>
                        <p className="subheader-dark mt-4">Don't just take our word for it. Hear from businesses that have successfully grown with our funding solutions.</p>
                        <a 
                        href="  https://g.page/r/CayKsPk0hsmNEAg/review" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="btn btn-primary d-flex justify-content-center w-100 mt-4 mb-4"
                      >
                        Check our reviews
                      </a>
                      
                      </>
                      }
                  </div>
                  <div className="col-12 col-lg-8 d-flex justify-content-center">
                    <div className="row w-100 d-flex align-items-stretch">
                      {/* First Column */}
                      <div className="col-12 col-md-4 d-flex flex-column">
                        <TestimonialBox {...testimonials[0]} />
                        <TestimonialBox {...testimonials[1]} />
                      </div>

                      {/* Second Column - Should fill height */}
                      <div className="col-12 col-md-4 d-flex flex-column">
                        <TestimonialBox {...testimonials[2]} />
                      </div>

                      {/* Third Column */}
                      <div className="col-12 col-md-4 d-flex flex-column">
                        <TestimonialBox {...testimonials[3]} />
                        <TestimonialBox {...testimonials[4]} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </>
    );
}
